module.exports = __webpack_public_path__ + "static/media/LogoCliente.c36c6042.png";